<template>

<header class="site-header">
  <div class="logo" style="margin-inline: auto; margin-top: 10%; margin-bottom: 5%">
    <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH'" style="filter: invert(60%);"/>
    <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" />
    <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" style="width: 100%; height: 100%;"/>
    <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;"/>
    <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
  </div>
  <nav class="navigation">
    <ul>

    </ul>
  </nav>
</header>

  <div class="container">
    <div class="header">

      <p>Clique abaixo para confirmar sua conta</p>
      
      <button type="button" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }" @click="confirmarConta" style="width: 40%;" class="submit-button">
          <span class="btnText" v-if="!disableBtnLogin">Confirmar conta</span>
          <div class="loadingDots" v-if="disableBtnLogin">
              <span class="dot">.</span>
              <span class="dot2">.</span>
              <span class="dot3">.</span>
          </div>
      </button>
   
    </div>
  </div>
</template>



<script>

import api from '@/api/axios';
import Cookies from 'js-cookie';

export default {
    name: 'ConfirmarConta',
    data() {
        return {
            nomeEmpresa: '',
            guidCliente: '',
            messageError: null,
            erro: false,
            disableBtnLogin: false
        };
    },
    mounted(){
      this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
      this.guidCliente = this.$route.params.id;
      this.disableBtnLogin = false;
    },
    methods: {
        async confirmarConta(){
          this.disableBtnLogin = true;
            if(this.guidCliente == ''){
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }

             const encodedCredentials = btoa('sat@sat:sat23!');
             var model = { ClienteGuid: this.guidCliente}

                    await api
                    .post('/register/ativar-conta', model, { headers: { 'Authorization': `Basic ${encodedCredentials}`}})
                    .then((retorno) => {
                        debugger// eslint-disable-line no-debugger
                        this.disableBtnLogin = false;
                        if(!retorno.data)
                        {
                            this.$swal({
                                icon: 'error',
                                title: 'Oops...',
                                text: `Falha na validação da conta`,
                            });
                        }
                        else
                        {
                          this.$swal({
                              icon: 'success',
                              title: 'E-mail validado com sucesso!',
                              text: `Faça o login para utilizar sua conta.`,
                          });
                          

                          this.$router.replace({
                            path: '/login',
                          });


                        }
                    })
                    .catch((error) => {
                      this.disableBtnLogin = false;
                        this.disableBtn = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `${error.response.data.descricao}`,
                        });
                    });



        },
        logoff(){
            localStorage.removeItem('ClienteId');
            localStorage.removeItem('NomeRazaoSocial');
            localStorage.removeItem('Email');
            localStorage.removeItem('token');
            Cookies.remove('nomeUsuarioLogado'); 
            
            this.$router.push({ name: 'UserLogin' });
        },
    }
};

</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* Estilos globais */
body, html {
  height: 100%;
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.site-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 2rem; /* Ajuste conforme necessário */
  background-color: #fff; /* Ou qualquer cor de fundo que você deseja */
}

.logo img {
  height: 32px; /* Ajuste conforme o tamanho desejado para o logo */
  width: 142px;
}

.navigation ul {
  list-style: none;
  display: flex;
  gap: 1rem; /* Espaço entre os itens de navegação */
}

.navigation li {
  padding: 0.5rem 1rem; /* Ajuste conforme necessário */
}

.navigation a {
  text-decoration: none;
  color: #000; /* Cor do texto */
}

.navigation a.router-link-active {
  color: #00235C; /* Cor quando o link está ativo */
}

/* Estilização específica para o botão de cadastro */
.navigation a.router-link-exact-active {
  background-color: #00235C; /* Cor de fundo para o botão de cadastro */
  color: #fff;
  border-radius: 5px; /* Raio da borda para fazer os cantos arredondados */
  padding: 0.5rem 1rem;
}


/* Estilos para o container do login */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  padding-top: 0px;
  border-radius: 10px;
  background-color: white;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.logomark{
    width: 54px;
    height: 43.2px;
}

.submit-button {
  width: 100%;
  padding: 0.5rem;
  margin-top: 1rem;
  color: white;
  border: none;
  background: #03204f;
  text-align: center;
  border: 1px solid #5E84C3;
  border-radius: 8px;
  cursor: pointer;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.header h2 {
  width: 360px; /* Largura do elemento */
  height: 38px; /* Altura do elemento */
  font-family: 'Gabarito', sans-serif; /* Família da fonte, certifique-se de que 'Gabarito' esteja importada ou substitua pelo nome correto da fonte */
  font-weight: 600; /* Peso da fonte semibold */
  font-size: 30px; /* Tamanho da fonte */
  line-height: 38px; /* Altura da linha */
  text-align: center; /* Alinhamento do texto ao centro */
  margin: 0 auto; /* Margem automática nas laterais para centralizar caso o elemento pai seja maior que 360px */
  color: #101828;
  margin-top: 20px;
}

.header p {
  font-family: 'Inter', sans-serif; /* Família da fonte Inter */
  font-weight: 400; /* Peso normal da fonte */
  font-size: 16px; /* Tamanho da fonte */
  line-height: 24px; /* Altura da linha */
  text-align: center; /* Alinhamento do texto ao centro */
  color: #6E6E6E; /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.footer p {
  font-family: 'Inter', sans-serif;
  color: #667085; /* Este é um cinza genérico, ajuste conforme necessário */
  font-size: 16px; /* Exemplo de tamanho de fonte, ajuste conforme necessário */
  line-height: 24px; /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
  font-weight: 600; /* Para 'Cadastre-se', que parece ser mais destacado */
  color: #101828; /* Este é o azul padrão de links, ajuste conforme necessário */
  text-decoration: none; /* Para sublinhar o link */
}

/* Aplicando estilos de fonte */
button {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
}

.entrar-button{
    color: #667085;
    background: white;
    cursor: pointer;
}

input {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px;
  margin-bottom: 16px; /* Ajuste para a linha de altura */
  border: 1px solid #ccc;
  border-radius: 8px; /* Arredondamento dos inputs */
  box-sizing: border-box; /* Garante que o padding não adicione largura extra */
  width: 100%; /* Para garantir que os inputs ocupem toda a largura do container */
    
 }

.erroBorder{
        border: 1px solid #E73D3D !important;
        margin-bottom: 0px;
}
 
.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}


/* Estilos para os rótulos (labels) do formulário */
.form .input-field label {
  font-family: 'Inter', sans-serif; /* Família da fonte Inter */
  font-weight: 500; /* Peso médio da fonte */
  font-size: 14px; /* Tamanho da fonte */
  line-height: 20px; /* Altura da linha */
  color: #344054; /* Cor do texto em cinza escuro */
}


/* Estilos para o formulário */
form {
  display: flex;
  flex-direction: column;
}

/* Estilos para os inputs */
input {
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Botão de entrar */
button {
  padding: 10px;
  background-color: #00235C;;
  color: white;
  border: none;
  border-radius: 4px;
  text-align: center;
}

/* Media query para telas menores */
@media (max-width: 600px) {
  .login-container {
    margin: 20px;
    padding: 10px;
  }

  input, button {
    margin-bottom: 10px;
  }
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.forgot-password {
  font-family: 'Inter', sans-serif;
  display: block;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
  color: #00064F;
  text-decoration: none;
}

.signup {
  text-align: center;
  margin-top: 20px;
}

.signup a {
  color: blue;
  text-decoration: none;
}


</style>